<div
  #widget
  class="account-switcher"
  cdkDrag
  cdkDragBoundary="body"
  [cdkDragFreeDragPosition]="position"
  (cdkDragEnded)="onDragEnd($event)"
>
  <!-- Drag Handle -->
  <div class="drag-area" cdkDragHandle>
    <svg width="15" height="15" class="cursor-pointer">
      <use [attr.href]="svgPath + 'sprite.svg#widget-drag'"></use>
    </svg>
  </div>

  <!-- Content -->
  <div class="content">
    <svg width="16" height="16">
      <use [attr.href]="svgPath + 'sprite.svg#widget-device'"></use>
    </svg>

    <div class="text">
      <span class="normal">You’re using</span>
      <span class="bold">{{ impersonateName }}’s</span>
      <span class="normal">Account</span>
    </div>
  </div>

  <!-- Switch User -->
  <button
    class="switch-user"
    (click)="switchAcc()"
    pTooltip="Switch account"
    tooltipPosition="top"
  >
    <svg width="15" height="15" class="cursor-pointer">
      <use [attr.href]="svgPath + 'sprite.svg#widget-profile'"></use>
    </svg>
  </button>

  <!-- Logout -->
  <button
    class="logout"
    (click)="originalUser()"
    pTooltip="Exit"
    tooltipPosition="top"
  >
    <svg width="18" height="18" class="cursor-pointer">
      <use [attr.href]="svgPath + 'sprite.svg#logout'"></use>
    </svg>
  </button>
</div>
